// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vip_update[data-v-0caf2309]{position:absolute;top:0;right:0;bottom:0;left:0;padding-top:35px;text-align:center}.vip_update .title[data-v-0caf2309]{display:flex;justify-content:center;margin-bottom:25px;line-height:24px;color:#666}.vip_update strong[data-v-0caf2309]{color:#4a96e8}", ""]);
// Exports
module.exports = exports;
